import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {BaseService} from "./base.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {AppUrl} from "../constants/app-url";

@Injectable({
  providedIn: 'root'
})
export class EnquiryService extends BaseService {
    constructor(public http: HttpClient, public alertService: AlertService, public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

add(data):Observable<void> {
      return this.postRequest(AppUrl.ENQUIRY(), data);
}

}
